import lodash from "lodash";
import { getLocalStorageData, setLocalStorageData } from "../../utils/utils";

export default {

  name: "vehicleTableSettingsModule",
  namespaced: true,
  state: {
    tableSettingsStorageKey: "vehicle.table.settings",

    pageIndex: 1,

    pageSize: 25,

    selectedHeaders: [],

    sort: {
      sortBy: [],
      sortDesc: [],
    },

    defaultSettings: {
      pageSize: 25,
      sort: {
        sortBy: [],
        sortDesc: [],
      },
      selectedHeaders: [],
    },
  },

  mutations: {
    changeSettings(state, data) {
      state.pageIndex = data.index;
      state.pageSize = data.size;
      state.sort = data.sort;
    },

    saveSettings(state) {
      const data = {
        pageSize: state.pageSize,
        sort: state.sort,
        selectedHeaders: state.selectedHeaders,
      };
      setLocalStorageData(state.tableSettingsStorageKey, JSON.stringify(data));
      state.defaultSettings = data;
    },

    applyDefaultSettings(state) {
      state.sort = { ...state.defaultSettings.sort };
      state.pageSize = state.defaultSettings.pageSize;
      state.selectedHeaders = state.defaultSettings.selectedHeaders || [];
    },

    updateHeaders(state, header) {
      state.selectedHeaders = header;
    },

    applyQuerySettings(state, query) {
      if (query.pageIndex) {
        state.pageIndex = +query.pageIndex;
      }
      if (query.pageSize) {
        state.pageSize = +query.pageSize;
      }
      if (query.sort) {
        state.sort = JSON.parse(query.sort);
      }
      if (query.columns) {
        state.selectedHeaders = JSON.parse(query.columns);
      }
    },
  },

  actions: {
    loadDefaultSettingsFromStorage({ state }, { headers }) {
      const data = getLocalStorageData(state.tableSettingsStorageKey);
      if (data) {
        const parsedSettings = JSON.parse(data);

        if (!parsedSettings.selectedHeaders) {
          parsedSettings.selectedHeaders = [...headers];
        }

        state.defaultSettings = parsedSettings;
      }
    },
  },

  getters: {
    isDefaultSettings: (state, getters) => getters.isDefaultSort && getters.isDefaultSize && getters.isDefaultHeaders,
    isDefaultSort: (state) => lodash.isEqual(state.sort, state.defaultSettings.sort),
    isDefaultSize: (state) => state.pageSize === state.defaultSettings.pageSize,
    isDefaultHeaders: (state) => lodash.isEqual(state.selectedHeaders, state.defaultSettings.selectedHeaders),
  },
};
